import _ from "lodash";
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

interface IUseTimerIntervalProps {
    callback: () => void;
    isContinueInterval?: boolean;
    onTimerEnd?: () => void;
    timeout: number;
}

function useTimerInterval(props: IUseTimerIntervalProps) {
    const { callback, timeout, onTimerEnd, isContinueInterval } = props;

    const timerRef = useRef<NodeJS.Timeout | null>();
    const savedCallback = useRef(null);
    const [isTimerRunning, setIsTimerRunning] = useState(false);

    useLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    const startTimer = useCallback(() => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(callback, timeout);
        setIsTimerRunning(true);
    }, [callback, timeout]);

    const stopTimer = useCallback(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
            setIsTimerRunning(false);
            onTimerEnd && onTimerEnd();
        }
    }, [onTimerEnd]);

    useEffect(() => {
        if (isTimerRunning && !_.isUndefined(isContinueInterval) && !isContinueInterval) {
            stopTimer();
        }
    }, [isContinueInterval, isTimerRunning, onTimerEnd, stopTimer]);


    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        }
    }, []);

    return { isTimerRunning, startTimer, stopTimer };
}

export default useTimerInterval;
